module.exports = __webpack_public_path__ + "img/MyGymChecker-Logomark-PNG-BlackBlue.caf614c6.png";